class GameSettings {
    cursorImage: string;

    constructor() {
        this.cursorImage = this.getRandomCursor();
    }

    public getRandomCursor(): string {
        const cursorsAvailable: string[] = [
            this.getCursorPath('double_bleu'),
            this.getCursorPath('double_pink'),
            this.getCursorPath('double_violet'),
            this.getCursorPath('double_yellow'),
            this.getCursorPath('light_blue'),
            this.getCursorPath('light_pink'),
            this.getCursorPath('light_purple'),
            this.getCursorPath('light_yellow'),
            this.getCursorPath('single_pink'),
            this.getCursorPath('single_purple'),
            this.getCursorPath('single_yellow'),
            this.getCursorPath('single_blue')
        ];
        const randomIndex = Math.floor(Math.random() * cursorsAvailable.length);
        return cursorsAvailable[randomIndex];
    }

    private getCursorPath(path: string) {
        return `url(/images/cursors/${path}.png)`;
    }
}

export default GameSettings;
